import request from '@/utils/request'

// 分页查询路由配置列表
export function paginationSettingRouter(query = {}, pagination) {
  return request({
    url: `/system/settingRouter/pagination?pageNum=${pagination.pageNum}&pageSize=${pagination.pageSize}`,
    method: 'post',
    data: query
  })
}

// 不分页查询路由配置列表
export function listSettingRouter(query = {}) {
  return request({
    url: '/system/settingRouter/list',
    method: 'post',
    data: query
  })
}

// 查询路由配置详细
export function getSettingRouter(routerSettingId) {
  return request({
    url: '/system/settingRouter/info/' + routerSettingId,
    method: 'get'
  })
}

// 新增路由配置
export function addSettingRouter(data) {
  return request({
    url: '/system/settingRouter/add',
    method: 'post',
    data: data
  })
}

// 修改路由配置
export function updateSettingRouter(data) {
  return request({
    url: '/system/settingRouter/edit',
    method: 'put',
    data: data
  })
}

// 删除路由配置
export function delSettingRouter(routerSettingId) {
  return request({
    url: '/system/settingRouter/remove/' + routerSettingId,
    method: 'delete'
  })
}
